<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Syarat dan Ketentuan</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule" class="pb-0" v-if="loadingApp == false">
            <div>
                <div class="section mt-2">
                    <div>
                        <div v-if="tos.length > 0">
                            <!-- item -->
                            <ul class="listview image-listview inset m-0">
                                <li v-for="item in tos" :key="item.id">
                                    <router-link
                                        :to="{
                                            name: 'tos.detail',
                                            params: {
                                                id: item.code,
                                            },
                                        }"
                                        class="item"
                                    >
                                        <div class="in">
                                            <div>
                                                <div>{{ item.name }}</div>
                                                <footer>
                                                    Perubahaan Terakhir :
                                                    {{
                                                        item
                                                            .tos_version_published
                                                            .published_at | date
                                                    }}
                                                </footer>
                                            </div>
                                        </div>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                        <div class="text-center" v-else>
                            <img
                                :src="require('@/assets/image/empty.webp')"
                                alt="404"
                                class="w-50"
                            /><br />
                            <h4 class="mb-0 text-secondary">
                                Belum ada transaksi
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions, mapState, mapMutations } from 'vuex';
    export default {
        data() {
            return {
                loadingApp: false,
            };
        },
        created() {},
        computed: {
            ...mapState(['toast', 'VUE_ENV', 'customer', 'setting']),
            ...mapState('tos', {
                tos: state => state.tos,
                loading: state => state.loading,
            }),
        },
        methods: {
            ...mapActions('tos', ['getTos']),
            ...mapMutations('tos', []),
        },

        mounted() {
            this.getTos();
        },
        destroyed() {},
    };
</script>
